/**
 * Festive events: the built-in festivals and the company's own events (anniversaries, annual day).
 * Shared by the API and the web app so both agree on the icon keys and the preset texts.
 */
/** Built-in festival icons (animated SVGs in the web app). */
export const FESTIVE_FESTIVAL_ICONS = ["diwali", "xmas", "newyear", "holi", "eid", "flag"];
/** Company event icons (static line icons in the web app). */
export const FESTIVE_COMPANY_ICONS = ["trophy", "cake", "party", "gift", "award", "star", "building"];
export const FESTIVE_ICON_KEYS = [...FESTIVE_FESTIVAL_ICONS, ...FESTIVE_COMPANY_ICONS];
/** ANNUAL repeats every year on month/day. ONE_TIME happens once on eventDate. */
export const FESTIVE_RECURRENCE = ["ANNUAL", "ONE_TIME"];
export const FESTIVE_DEFAULT_WINDOW_DAYS = 7;
export const FESTIVE_MAX_WINDOW_DAYS = 30;
/**
 * Built-in festivals, offered as one-click defaults in the admin. The migration that creates
 * festive_events seeds the same rows. Moving festivals start with no date.
 */
export const FESTIVE_PRESETS = [
    {
        presetKey: "diwali", name: "Diwali", greeting: "Happy Diwali",
        message: "Wishing you and your team a bright and prosperous festival of lights.",
        icon: "diwali", accent: "#FFC978", recurrence: "ONE_TIME", month: null, day: null,
    },
    {
        presetKey: "xmas", name: "Christmas", greeting: "Merry Christmas",
        message: "Wishing you and your team a warm and joyful holiday season.",
        icon: "xmas", accent: "#FF9AA0", recurrence: "ANNUAL", month: 12, day: 25,
    },
    {
        presetKey: "newyear", name: "New Year", greeting: "Happy New Year",
        message: "Wishing you and your team a successful and rewarding year ahead.",
        icon: "newyear", accent: "#FFD166", recurrence: "ANNUAL", month: 1, day: 1,
    },
    {
        presetKey: "holi", name: "Holi", greeting: "Happy Holi",
        message: "Wishing you and your team a colourful and joyful celebration.",
        icon: "holi", accent: "#FF9CC2", recurrence: "ONE_TIME", month: null, day: null,
    },
    {
        presetKey: "eid", name: "Eid", greeting: "Eid Mubarak",
        message: "Wishing you and your team peace, joy and blessings.",
        icon: "eid", accent: "#FFD166", recurrence: "ONE_TIME", month: null, day: null,
    },
    {
        presetKey: "flag", name: "Independence Day", greeting: "Happy Independence Day",
        message: "Wishing you and your team a proud and joyful celebration.",
        icon: "flag", accent: "#FFB36B", recurrence: "ANNUAL", month: 8, day: 15,
    },
];
//# sourceMappingURL=festive.js.map